import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import "./headerCss/TemplateModal.css";

// ============================================================
// TEMPLATE DEFINITIONS — pulled from live Meta API 2026-06-30
// WABA ID: 120126377855203  |  Phone Number ID: 128538200341271
// ============================================================
export const WHATSAPP_TEMPLATES = [
  {
    name: "refund_processed",
    label: "Refund Processed",
    icon: "💰",
    description: "Notify customer their refund has been processed",
    language: "en_US",
    headerPreview: null,
    bodyPreview:
      "Good news, [Customer Name] — your refund for order *#[Order ID]* (Refund ID: [Refund ID]) has been processed. Amount: [Amount]. It should appear in your account within [Days] business days.",
    footerPreview: null,
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Customer Name", placeholder: "e.g. Rahul Sharma" },
      { key: "1", label: "Order ID", placeholder: "e.g. 12345" },
      { key: "2", label: "Refund ID", placeholder: "e.g. REF-001" },
      { key: "3", label: "Amount", placeholder: "e.g. ₹499" },
      { key: "4", label: "Business Days", placeholder: "e.g. 5" },
    ],
  },
  {
    name: "return_received",
    label: "Return Received",
    icon: "📦",
    description: "Confirm that returned item has been received",
    language: "en",
    headerPreview: null,
    bodyPreview:
      "Update: We've received your returned item for return ID [Return ID]. Refund processing will begin and may take [Days] business days.",
    footerPreview: "LEDSHOES",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Return ID", placeholder: "e.g. RET-456" },
      { key: "1", label: "Business Days", placeholder: "e.g. 3" },
    ],
  },
  {
    name: "return_initiated",
    label: "Return Initiated",
    icon: "🔄",
    description: "Confirm the customer's return request has been received",
    language: "en_US",
    headerPreview: null,
    bodyPreview:
      "Hi [Customer Name], we've received your return request for order *#[Order ID]* ([Items]). Return ID: [Return ID]. We'll notify you when we receive the item.",
    footerPreview: "LEDSHOES",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Customer Name", placeholder: "e.g. Priya" },
      { key: "1", label: "Order ID", placeholder: "e.g. 78901" },
      { key: "2", label: "Item(s)", placeholder: "e.g. LED Shoes Size 8" },
      { key: "3", label: "Return ID", placeholder: "e.g. RET-789" },
    ],
  },
  {
    name: "order_delivered_confirmed",
    label: "Order Delivered",
    icon: "✅",
    description: "Confirm order has been successfully delivered",
    language: "en_US",
    headerPreview: null,
    bodyPreview:
      "Hello [Customer Name], your order *#[Order ID]* has been delivered on [Delivery Date]. We hope you enjoy your purchase — please reply if anything is wrong.",
    footerPreview: "LEDSHOES",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Customer Name", placeholder: "e.g. Amit" },
      { key: "1", label: "Order ID", placeholder: "e.g. 55321" },
      { key: "2", label: "Delivery Date", placeholder: "e.g. June 30, 2026" },
    ],
  },
  {
    name: "tracking_link_cta",
    label: "Tracking Link",
    icon: "🚚",
    description: "Send order tracking info with a CTA button",
    language: "en_US",
    headerPreview: "Track your order #[Order ID]",
    bodyPreview:
      "Your order *#[Order ID]* is on the way. Tap the button below to see real-time tracking.",
    footerPreview: "If the link doesn't work, reply and we'll assist.",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Order ID", placeholder: "e.g. 66789" },
    ],
  },
  {
    name: "order_confirmation_friendly",
    label: "Order Confirmed (Friendly)",
    icon: "🎉",
    description: "Friendly order confirmation with details",
    language: "en_US",
    headerPreview: "Order confirmed — [Order ID]",
    bodyPreview:
      "Awesome, [Customer Name]! 🎉 Your order *#[Order ID]* is all set. Items: [Items]. Total: [Total]. We'll send updates when it ships.",
    footerPreview: null,
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Order ID", placeholder: "e.g. 99001" },
      { key: "1", label: "Customer Name", placeholder: "e.g. Sneha" },
      { key: "2", label: "Item(s)", placeholder: "e.g. LED Shoes x2" },
      { key: "3", label: "Total Amount", placeholder: "e.g. ₹1,298" },
    ],
  },
  {
    name: "order_cancelled",
    label: "Order Cancelled",
    icon: "❌",
    description: "Inform customer that their order has been cancelled",
    language: "en_US",
    headerPreview: null,
    bodyPreview:
      "Hi [Customer Name], your order *#[Order ID]* has been cancelled as requested. If you opted for a refund, it will be processed within [Days] business days. Need anything else?",
    footerPreview: "LEDSHOES",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Customer Name", placeholder: "e.g. Rohan" },
      { key: "1", label: "Order ID", placeholder: "e.g. 44120" },
      { key: "2", label: "Business Days", placeholder: "e.g. 7" },
    ],
  },
  {
    name: "order_confirmation_formal",
    label: "Order Confirmed (Formal)",
    icon: "📋",
    description: "Formal order confirmation with full details",
    language: "en",
    headerPreview: "Order #[Order ID]",
    bodyPreview:
      "Hi [Customer Name], thank you for shopping with [Store Name]. We've confirmed your order *#[Order ID]* for [Items]. Total: [Total]. Estimated delivery: [Delivery Date].",
    footerPreview: "LEDSHOES",
    hasMediaHeader: false,
    fields: [
      { key: "0", label: "Order ID", placeholder: "e.g. 11234" },
      { key: "1", label: "Customer Name", placeholder: "e.g. Kavya" },
      { key: "2", label: "Store Name", placeholder: "e.g. LEDSHOES" },
      { key: "3", label: "Item(s)", placeholder: "e.g. LED Shoes Size 7" },
      { key: "4", label: "Total Amount", placeholder: "e.g. ₹699" },
      { key: "5", label: "Estimated Delivery Date", placeholder: "e.g. July 5, 2026" },
    ],
  },
  {
    name: "our_first_temp",
    label: "LED Shoes Promo",
    icon: "👟",
    description: "Promotional message with image + buy button",
    language: "en",
    headerPreview: null,
    bodyPreview:
      "Hi,\n\nBuy your most favourite LED shoes right away. with 30 days return policy with the facility to purchase with prepaid and COD.\n\nCheers!\nLedshoes.in",
    footerPreview: "Led Shoes in the never seen before price.",
    hasMediaHeader: true,
    fields: [],
  },
  {
    name: "hello_world",
    label: "Hello World",
    icon: "👋",
    description: "Meta's default test template — no variables needed",
    language: "en_US",
    headerPreview: "Hello World",
    bodyPreview:
      "Welcome and congratulations!! This message demonstrates your ability to send a WhatsApp message notification from the Cloud API, hosted by Meta. Thank you for taking the time to test with us.",
    footerPreview: "WhatsApp Business Platform sample message",
    hasMediaHeader: false,
    fields: [],
  },
];

// ============================================================
// TEMPLATE DROPDOWN — shown in Header
// ============================================================
export function TemplateDropdown({ onSelect, onClose }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [onClose]);

  const getVarCount = (t) => {
    if (t.hasMediaHeader) return "📷 Image";
    const total = t.fields.length;
    if (total === 0) return "No vars";
    return `${total} var${total > 1 ? "s" : ""}`;
  };

  return (
    <div className="tm-dropdown" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
      <div className="tm-dropdown-header">📋 &nbsp;WhatsApp Templates — 10 Approved</div>
      {WHATSAPP_TEMPLATES.map((t) => (
        <button
          key={t.name}
          className="tm-dropdown-item"
          onClick={() => {
            onSelect(t);
            onClose();
          }}
        >
          <span className="tm-item-icon">{t.icon}</span>
          <span className="tm-item-info">
            <span className="tm-item-name">{t.label}</span>
            <span className="tm-item-desc">{t.description}</span>
          </span>
          <span className="tm-item-badge">{getVarCount(t)}</span>
        </button>
      ))}
    </div>
  );
}

// ============================================================
// TEMPLATE MODAL — popup form to fill variables and send
// ============================================================
function TemplateModal({ template, currentUser, onClose }) {
  const [fieldValues, setFieldValues] = useState({});
  const [mediaFile, setMediaFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const fileInputRef = useRef(null);

  const API_URL = "https://casualfootwears.com/api/wp-send-template-api-for-website/";

  const handleFieldChange = (key, value) => {
    setFieldValues((prev) => ({ ...prev, [key]: value }));
    setError("");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMediaFile(file);
      setError("");
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    setError("");

    // Validate all text fields filled
    for (const field of template.fields) {
      if (!fieldValues[field.key] || fieldValues[field.key].trim() === "") {
        setError(`Please fill in "${field.label}"`);
        return;
      }
    }

    // Validate media for our_first_temp
    if (template.hasMediaHeader && !mediaFile) {
      setError("Please upload an image for this template.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("template_name", template.name);
      formData.append("profile_name", currentUser.name || "Customer");
      formData.append("to_number", currentUser.phone);
      formData.append("from_number", currentUser.wb_num || "918278244128");

      // Build components array from field values in order
      template.fields.forEach((field) => {
        formData.append("components", fieldValues[field.key]?.trim() || "");
      });

      if (template.hasMediaHeader && mediaFile) {
        formData.append("media", mediaFile);
        formData.append("media_type", "image");
      }

      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        setSuccess(true);
        toast.success(`✅ Template "${template.label}" sent!`, {
          style: { background: "#075e54", color: "#fff" },
        });
        setTimeout(() => onClose(), 1400);
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.error ||
        err?.message ||
        "Failed to send template. Please try again.";
      setError(errMsg);
      toast.error("Failed to send template");
    } finally {
      setLoading(false);
    }
  };

  // Highlight {{N}} vars in preview text with colored spans
  const renderPreviewText = (text) => {
    if (!text) return null;
    const parts = text.split(/(\[.*?\])/g);
    return parts.map((part, i) => {
      if (part.startsWith("[") && part.endsWith("]")) {
        return (
          <span key={i} className="tm-preview-var">
            {part}
          </span>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  return (
    <div className="tm-overlay" onClick={onClose}>
      <div className="tm-card" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="tm-header">
          <div className="tm-header-left">
            <span className="tm-header-icon">{template.icon}</span>
            <div className="tm-header-text">
              <h2>{template.label}</h2>
              <p>Lang: {template.language.toUpperCase()} &nbsp;·&nbsp; Status: APPROVED</p>
            </div>
          </div>
          <button className="tm-close-btn" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="tm-body">
          {/* Preview bubble */}
          <div className="tm-preview">
            <div className="tm-preview-label">📱 Template Preview</div>
            <div className="tm-preview-bubble">
              {template.hasMediaHeader && (
                <div className="tm-preview-media-badge">📷 Image header (uploaded by you)</div>
              )}
              {template.headerPreview && (
                <div className="tm-preview-header">
                  {renderPreviewText(template.headerPreview)}
                </div>
              )}
              <div>{renderPreviewText(template.bodyPreview)}</div>
              {template.footerPreview && (
                <div className="tm-preview-footer">{template.footerPreview}</div>
              )}
            </div>
          </div>

          {/* Fields */}
          {(template.fields.length > 0 || template.hasMediaHeader) && (
            <>
              <div className="tm-fields-label">✏️ Fill in the details</div>

              {template.fields.map((field) => (
                <div key={field.key} className="tm-field-group">
                  <label className="tm-field-label">
                    {field.label}
                    <span style={{ color: "#ff6b6b", marginLeft: 3 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="tm-field-input"
                    placeholder={field.placeholder}
                    value={fieldValues[field.key] || ""}
                    onChange={(e) => handleFieldChange(field.key, e.target.value)}
                    disabled={loading}
                  />
                </div>
              ))}

              {template.hasMediaHeader && (
                <div className="tm-field-group">
                  <label className="tm-field-label">
                    Header Image
                    <span style={{ color: "#ff6b6b", marginLeft: 3 }}>*</span>
                  </label>
                  <div
                    className="tm-field-file"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={loading}
                    />
                    <span className="tm-file-icon">🖼️</span>
                    {mediaFile ? (
                      <span className="tm-file-name">✓ {mediaFile.name}</span>
                    ) : (
                      <>
                        <span style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.82rem" }}>
                          Click to choose image
                        </span>
                        <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.7rem", marginTop: 3 }}>
                          JPG, PNG, WEBP
                        </span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </>
          )}

          {template.fields.length === 0 && !template.hasMediaHeader && (
            <div style={{ textAlign: "center", color: "rgba(255,255,255,0.45)", fontSize: "0.82rem", paddingTop: 8 }}>
              This template has no variables — it will be sent as-is.
            </div>
          )}

          {error && <div className="tm-error-msg">⚠️ {error}</div>}
          {success && <div className="tm-success-msg">✅ Template sent successfully!</div>}
        </div>

        {/* Footer */}
        <div className="tm-footer">
          <button className="tm-cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="tm-send-btn"
            onClick={handleSend}
            disabled={loading || success}
          >
            {loading ? (
              <>
                <span className="tm-spinner" />
                Sending...
              </>
            ) : success ? (
              "✓ Sent!"
            ) : (
              <>📤 Send Template</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TemplateModal;
